import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import toast from "react-hot-toast";
import moment from 'moment'

import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";

import TextInput from '../components/TextInput';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale/pt-BR";


interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,

}

interface iOpcao {

    id: number,
    nome: string,
    documento: string,

}

interface iDados {

    emissao_id: number,
    pin: string,
    tomador: string,
    favorecido: string,
    dataEmissao: string,
    dataInicio: string,
    dataVencimento: string,
    valor: number | null,
    pago: number,
    valorPago: number | null,
    taxa: number | null,
    sinistro: number,
    bloqueada: number,

}


// mesmas opções do menu Relatório > Garantias do sistema legado (crm_garantia_view.asp)
const filtros: { [key: string]: string } = {
    vencidas: 'Vencidas (até o dia de ontem)',
    aVencer: 'A vencer (de hoje em diante)',
    naoPagas: 'Não pagas',
    pagas: 'Pagas',
    periodo: 'Por período',
    porTomador: 'Por tomador',
    porFavorecido: 'Por favorecido',
    porCorretor: 'Por corretor',
    todas: 'Todas',
    sinistro: 'Com sinistro',
    foraDoAr: 'Fora do ar',
    semValor: 'Sem valor pago',
}

// filtros que precisam de seleção do usuário antes de consultar
const filtrosComSelecao = ['periodo', 'porTomador', 'porFavorecido', 'porCorretor']

const moeda = (valor: number | null | undefined) => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })


const RelatorioGarantia = () => {

    const [searchParams] = useSearchParams()

    const [resultado, setResultado] = useState<iDados[]>([])
    const [consultado, setConsultado] = useState<boolean>(false)
    const [carregando, setCarregando] = useState<boolean>(false)

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])

    const [corretores, setCorretores] = useState<iOpcao[]>([])
    const [tomadores, setTomadores] = useState<iOpcao[]>([])
    const [favorecidos, setFavorecidos] = useState<iOpcao[]>([])

    const [filtro, setFiltro] = useState<string>(filtros[searchParams.get('filtro') || ''] ? searchParams.get('filtro') || '' : 'todas')
    const [corretor_id, setCorretor_id] = useState<string>(searchParams.get('corretor_id') || '')
    const [tomador_id, setTomador_id] = useState<string>('')
    const [favorecido_id, setFavorecido_id] = useState<string>('')
    const [pago, setPago] = useState<string>(searchParams.get('pago') || '')
    const [periodo, setPeriodo] = useState<string>('emissao')

    const today = new Date()

    const [startDate, setDate] = useState(new Date(today.getFullYear(), 0, 1));
    const [startDate2, setDate2] = useState(new Date());


    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)

        }

    }, [dadosUsuarios])


    const carregaFiltros = async () => {

        try {

            const response = await api.post('relGarantiaFiltros', { cliente_id: cliente_id })

            setCorretores(response.data.corretores)
            setTomadores(response.data.tomadores)
            setFavorecidos(response.data.favorecidos)

        } catch (err) {
            console.error(err)
            toast.error('Erro ao carregar corretores, tomadores e favorecidos')
        }

    }


    const montaDataPost = () => {

        if (!cliente_id) {
            toast.error('Selecione uma afiançadora')
            return undefined
        }

        if (filtro == 'porCorretor' && corretor_id == '') {
            toast.error('Selecione o corretor')
            return undefined
        }

        if (filtro == 'porTomador' && tomador_id == '') {
            toast.error('Selecione o tomador')
            return undefined
        }

        if (filtro == 'porFavorecido' && favorecido_id == '') {
            toast.error('Selecione o favorecido')
            return undefined
        }

        if (filtro == 'periodo' && (!startDate || !startDate2)) {
            toast.error('Informe a data de início e de fim')
            return undefined
        }

        return {
            cliente_id: cliente_id,
            filtro: filtro,
            corretor_id: (filtro == 'porCorretor' || filtro == 'periodo') && corretor_id != '' ? Number(corretor_id) : null,
            tomador_id: filtro == 'porTomador' ? Number(tomador_id) : null,
            favorecido_id: filtro == 'porFavorecido' ? Number(favorecido_id) : null,
            pago: filtro == 'porCorretor' ? pago : null,
            periodo: filtro == 'periodo' ? periodo : null,
            dataInicio: filtro == 'periodo' ? moment(startDate).format('YYYY-MM-DD') : null,
            dataFim: filtro == 'periodo' ? moment(startDate2).format('YYYY-MM-DD') : null,
        }

    }


    const consulta = async () => {

        const dataPost = montaDataPost()

        if (!dataPost) {
            return false
        }

        setResultado([])
        setCarregando(true)

        try {

            const response = await api.post('relGarantia', dataPost)
            setResultado(response.data)
            setConsultado(true)

        } catch (err) {
            console.error(err)
            toast.error('Erro ao gerar relatório')
        } finally {
            setCarregando(false)
        }

    }


    const exportaExcel = async () => {

        const dataPost = montaDataPost()

        if (!dataPost) {
            return false
        }

        try {
            const response = await api.post<Blob>('excelGarantia', dataPost, {
                responseType: "blob",
                validateStatus: (status) => true // para não cair direto no catch
            });

            if (response.status !== 200) {
                // ler como texto para ver o erro real
                const errorText = await response.data.text();
                console.error("Erro backend:", errorText);
                toast.error("Erro ao exportar: " + errorText);
                return;
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `relGarantias.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success("Download concluído!");
        } catch (err) {
            console.error(err);
            toast.error("Falha ao baixar arquivo");
        }

    }


    useEffect(() => {

        if (cliente_id) {

            carregaFiltros()

            // como no legado, os relatórios que não dependem de seleção já abrem consultados
            if (!filtrosComSelecao.includes(filtro) || (filtro == 'porCorretor' && corretor_id != '')) {
                consulta()
            }

        }

    }, [cliente_id])


    const cabecalho = () => {

        if (filtro == 'porCorretor') {

            const corretor = corretores.find(rs => String(rs.id) == corretor_id)
            const situacao = pago == '1' ? 'Pagas' : pago == '0' ? 'Em aberto' : 'Todas'
            return `Corretor: ${corretor ? corretor.nome : ''} - ${situacao}`

        }

        if (filtro == 'periodo') {

            return `Por período: ${moment(startDate).format('DD/MM/YYYY')} até ${moment(startDate2).format('DD/MM/YYYY')}`

        }

        return filtros[filtro]

    }


    const valorTotal = resultado.reduce((t, rs) => t + Number(rs.valor || 0), 0)
    const valorPagas = resultado.reduce((t, rs) => t + (rs.pago ? Number(rs.valorPago || 0) : 0), 0)
    const valorNaoPagas = resultado.reduce((t, rs) => t + (!rs.pago ? Number(rs.valorPago || 0) : 0), 0)


    const colunaMoeda = (accessorKey: 'valor' | 'valorPago', header: string): MRT_ColumnDef<iDados> => ({
        accessorKey: accessorKey,
        header: header,
        muiTableHeadCellProps: { align: 'right' },
        muiTableBodyCellProps: { align: 'right' },
        Cell: ({ cell }) => cell.getValue() == null ? 'Sem valor' : moeda(cell.getValue<number>()),
    })


    const columns: MRT_ColumnDef<iDados>[] = [

        { accessorKey: 'pin', header: 'Código' },
        { accessorKey: 'tomador', header: 'Tomador' },
        { accessorKey: 'favorecido', header: 'Favorecido' },
        { accessorKey: 'dataEmissao', header: 'Emissão' },
        { accessorKey: 'dataInicio', header: 'Início' },
        { accessorKey: 'dataVencimento', header: 'Vencimento' },
        colunaMoeda('valor', 'Valor'),
        {
            accessorKey: 'pago',
            header: 'PG',
            muiTableHeadCellProps: { align: 'center' },
            muiTableBodyCellProps: { align: 'center' },
            Cell: ({ cell }) => cell.getValue() ? 'Sim' : 'Não',
        },
        colunaMoeda('valorPago', 'Valor PG'),
        {
            accessorKey: 'taxa',
            header: 'Taxa',
            muiTableHeadCellProps: { align: 'center' },
            muiTableBodyCellProps: { align: 'center' },
            Cell: ({ cell }) => cell.getValue() == null ? '-' : `${cell.getValue()} %`,
        },

    ]


    return (

        <div>

            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Relatório</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">Garantias</li>
                            <li className="breadcrumb-item active" aria-current="page">{cabecalho()}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="row g-3">

                <div className="col-md-3">
                    <label className="form-label">Relatório *</label>
                    <select className="form-control" value={filtro} onChange={event => { setFiltro(event.target.value); setResultado([]); setConsultado(false) }} >
                        {
                            Object.keys(filtros).map((key) =>
                                <option key={key} value={key}>{filtros[key]}</option>
                            )
                        }
                    </select>
                </div>

                {
                    filtro == 'periodo' && (

                        <>

                            <div className="col-md-2">
                                <label className="form-label">Data início *</label>
                                <DatePicker
                                    className="form-control"
                                    locale={ptBR}
                                    wrapperClassName="w-100"
                                    dateFormat="dd/MM/yyyy"
                                    selected={startDate}
                                    onChange={(d: any) => setDate(d)}
                                    customInput={
                                        <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />
                                    }
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Data fim *</label>
                                <DatePicker
                                    className="form-control"
                                    locale={ptBR}
                                    wrapperClassName="w-100"
                                    dateFormat="dd/MM/yyyy"
                                    selected={startDate2}
                                    onChange={(d: any) => setDate2(d)}
                                    customInput={
                                        <TextInput placeholder="DD/MM/AAAA" maskType="date" className="form-control" />
                                    }
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Período *</label>
                                <select className="form-control" value={periodo} onChange={event => setPeriodo(event.target.value)} >
                                    <option value="emissao">Por Emissão</option>
                                    <option value="vencimento">Por Vencimento</option>
                                    <option value="cadastro">Por Cadastro</option>
                                    <option value="inicio">Por Início</option>
                                </select>
                            </div>

                        </>

                    )
                }

                {
                    (filtro == 'periodo' || filtro == 'porCorretor') && (

                        <div className="col-md-3">
                            <label className="form-label">Corretor{filtro == 'porCorretor' ? ' *' : ''}</label>
                            <select className="form-control" value={corretor_id} onChange={event => setCorretor_id(event.target.value)} >
                                <option value="">{filtro == 'periodo' ? 'TODOS' : '[Selecione o corretor]'}</option>
                                {
                                    corretores.map((rs) =>
                                        <option key={rs.id} value={rs.id}>{rs.nome}</option>
                                    )
                                }
                            </select>
                        </div>

                    )
                }

                {
                    filtro == 'porCorretor' && (

                        <div className="col-md-2">
                            <label className="form-label">Situação</label>
                            <select className="form-control" value={pago} onChange={event => setPago(event.target.value)} >
                                <option value="">Todas</option>
                                <option value="1">Pagas</option>
                                <option value="0">Em aberto</option>
                            </select>
                        </div>

                    )
                }

                {
                    filtro == 'porTomador' && (

                        <div className="col-md-6">
                            <label className="form-label">Tomador *</label>
                            <select className="form-control" value={tomador_id} onChange={event => setTomador_id(event.target.value)} >
                                <option value="">[Selecione o tomador]</option>
                                {
                                    tomadores.map((rs) =>
                                        <option key={rs.id} value={rs.id}>{rs.nome}{rs.documento ? ` - ${rs.documento}` : ''}</option>
                                    )
                                }
                            </select>
                        </div>

                    )
                }

                {
                    filtro == 'porFavorecido' && (

                        <div className="col-md-6">
                            <label className="form-label">Favorecido *</label>
                            <select className="form-control" value={favorecido_id} onChange={event => setFavorecido_id(event.target.value)} >
                                <option value="">[Selecione o favorecido]</option>
                                {
                                    favorecidos.map((rs) =>
                                        <option key={rs.id} value={rs.id}>{rs.nome}{rs.documento ? ` - ${rs.documento}` : ''}</option>
                                    )
                                }
                            </select>
                        </div>

                    )
                }

                <div className="col-md-3">
                    <label className="form-label">Afiançadora</label>
                    <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                        {clientes.length > 1 && (<option value="">[Selecione]</option>)}
                        {
                            clientes.map((rs: iClientes) =>
                                <option key={rs.cliente_id} value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                            )
                        }
                    </select>
                </div>

            </div>


            <div className="col-md-12" style={{ marginTop: 20, marginBottom: 20 }}>
                <div className="d-md-flex d-grid align-items-center gap-2">
                    <button type="button" className="btn btn-info" onClick={consulta}>Procurar</button>
                    <button type="button" className="btn btn-success" onClick={exportaExcel}>Excel</button>
                </div>
            </div>


            <center>
                <LoaderIcon.Puff stroke="#000" style={{ display: carregando ? 'block' : 'none' }} />
            </center>


            <div style={{ display: consultado && !carregando ? 'block' : 'none' }}>

                <MaterialReactTable
                    columns={columns}
                    data={resultado}
                    localization={MRT_Localization_PT_BR}
                    initialState={{ density: 'compact', pagination: { pageIndex: 0, pageSize: 20 } }}
                    muiTableHeadCellProps={{
                        sx: { fontSize: { xs: '8px', sm: '9px', md: '10px', lg: '11px', xl: '12px' } },
                    }}
                    // legenda do legado: sinistro em vermelho, fora do ar em amarelo/negrito
                    muiTableBodyCellProps={({ row }) => ({
                        sx: {
                            fontSize: { xs: '8px', sm: '9px', md: '10px', lg: '11px', xl: '12px' },
                            color: row.original.sinistro ? '#B22222' : row.original.bloqueada ? '#B2B200' : undefined,
                            fontWeight: row.original.sinistro || row.original.bloqueada ? 'bold' : undefined,
                        },
                    })}
                />

                <div className="card mt-3">
                    <div className="card-body">

                        <p className="mb-1">Total de <b>{resultado.length}</b> registros</p>
                        <p className="mb-1"><span style={{ color: '#B22222', fontWeight: 'bold' }}>Vermelho</span>: com sinistro &nbsp;-&nbsp; <span style={{ color: '#B2B200', fontWeight: 'bold' }}>Amarelo</span>: fora do ar</p>

                        <hr />

                        <p className="mb-1"><b>Valor total das garantias:</b> {moeda(valorTotal)}</p>
                        <p className="mb-1"><b>Garantias pagas:</b> {moeda(valorPagas)}</p>
                        <p className="mb-1"><b>Garantias não-pagas:</b> {moeda(valorNaoPagas)}</p>
                        <br />
                        <p className="mb-1"><b>Média por garantia (valor da garantia):</b> {moeda(resultado.length ? valorTotal / resultado.length : 0)}</p>
                        <p className="mb-0"><b>Média por garantia (valor a ser recebido):</b> {moeda(resultado.length ? (valorPagas + valorNaoPagas) / resultado.length : 0)}</p>

                    </div>
                </div>

            </div>

        </div>

    )

}

export default RelatorioGarantia
